import { useSelector } from 'react-redux'
import moment from 'moment'
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography } from '@mui/material'

import Search from '../Search/SearchBar'
import Personal from './Personal/Personal'
import TableHeader from './TableHeader'

const Summary = () => {

  const products = useSelector(state => state.products)
  const retailer = JSON.parse(localStorage.getItem('retailer'))
  
  const bgColor = retailer ? 'mediumorchid' : '#337ab7'

const rows = products.map( product => {
  return {title: product.title, quantity: product.quantity, retailerName: product.name,  addedDate: product.addedDate, category: product.category}
})

return (
  <>
  <Search retailer={retailer} />

  {retailer && (
    <Personal retailer={retailer} bgColor={bgColor} products={products} rows={rows} />
  )}
  
    <Typography variant='h5' align='center' gutterBottom >All</Typography>
    <TableContainer elevation={3} sx={{ width: '80%', margin: 'auto' }} component={Paper}>
      <Table aria-label="simple table">
        <TableHeader bgColor={bgColor} />
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.addedDate}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.title}
              </TableCell>
              <TableCell align="right">{row.quantity}</TableCell>
              <TableCell align="right">{row.retailerName}</TableCell>
              <TableCell align="right">{moment(row.addedDate).fromNow()}</TableCell>
              <TableCell align="right">{row.category}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
  );
}
export default Summary;